import { API } from '../helpers/API';
import { IReferential } from '../interfaces/IReferential';
import {
  GetAllLegalDocumentsPayload,
  LegalDocumentsResponse,
  LegalDocumentType,
  AcceptLatestsConnectLegalDocumentsPayload
} from '../interfaces/LegalDocument';

export class LegalDocumentService {
  public async GetAllLegalDocuments(
    payload: GetAllLegalDocumentsPayload
  ): Promise<LegalDocumentsResponse> {
    return (
      await API.Post2Async<GetAllLegalDocumentsPayload, LegalDocumentsResponse>(
        '/organization/fleet/legal-documents',
        payload
      )
    ).data;
  }

  public async DownloadLegalDocument(filename: string): Promise<Blob> {
    return (await API.GetFileAsync<Blob>(`/organization/fleet/legal-document/${filename}`)).data;
  }

  public async CreateLegalDocument(formData: FormData): Promise<LegalDocumentType> {
    const access_token = localStorage.getItem('access_token');
    const axios = (await import('../helpers/AxiosInstance')).default;
    return (
      await axios.post<LegalDocumentType>('/organization/fleet/legal-document', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + access_token,
          'Content-Type': 'multipart/form-data'
        }
      })
    ).data;
  }

  public async GetLastLegalDocumentVersionByType(
    documentType: number,
    appTypeId: number
  ): Promise<Blob> {
    return (
      await API.GetFileAsync<Blob>(
        `/organization/fleet/legal-document/${documentType}/last-version/${appTypeId}`
      )
    ).data;
  }

  public async GetLegalDocumentTypes(): Promise<IReferential[]> {
    return (
      await API.GetAsync<IReferential[]>(
        '/organization/referential/fleetLegalDocumentType'
      )
    ).data;
  }

  public async GetAppTypes(): Promise<IReferential[]> {
    return (await API.GetAsync<IReferential[]>('/organization/Referential/AppType')).data;
  }

  public async AcceptLatestsLegalDocuments(
    payload: AcceptLatestsConnectLegalDocumentsPayload
  ): Promise<void> {
    await API.PutAsync('IdentityAdmin/UpdateLegalDocumentAcknowledgement', payload);
  }
}
